export const CHATBOT_UNAVAILABLE_MESSAGE_CONTAINER_ID = "chatbot-unavailable-message-container";

export const CHATBOT_UNAVAILABLE_MESSAGE_KEY = "AI_ASSISTANT_PAYWALL_MESSAGE";
export const CHATBOT_UNAVAILABLE_MESSAGE_DEFAULT_VALUE = `👋 Ciao %Nome%! Sono %AssistantName%, l'assistente virtuale di BonusX.
\\
\\
Aiuto le persone in cose come burocrazia, bonus pubblici e tasse, 24 ore su 24, 7 giorni su 7.  
\\
Passa a %FREEMIUM_TIER1% o %FREEMIUM_TIER2% per sbloccare tutte le mie funzionalità.`;

export const CHATBOT_UNAIVAILABLE_IN_ANY_TIER_DEFAULT_MESSAGE = `👋 Ciao, sono l'assistente virtuale di BonusX.
\\
\\
Aiuto le persone in cose come burocrazia, bonus pubblici e tasse! Purtroppo, al momento non sono disponibile.`;
